import type { ForwardRefRenderFunction } from 'react';
import React, { forwardRef } from 'react';
import { Button } from '@THC/components/Button';
import { DownloadIcon } from '@THC/components/Icons';
import { MDText } from 'i18n-react';

import { applyCypressData } from 'Utilities/helpers';

import texts from '../DownloadCSV.texts';
import { DownloadCSVButtonTooltip } from '../DownloadCSVButtonTooltip/DownloadCSVButtonTooltip';

import type { DownloadCSVButtonProps } from './DownloadCSVButton.types';

import styles from './DownloadCSVButton.module.scss';

const T = new MDText(texts);

const DownloadCSVButton: ForwardRefRenderFunction<HTMLButtonElement, DownloadCSVButtonProps> = (
	{ className, cypressId, downloadButtonLabel, isDisabled, isLoading, isPopoverOpen, onClick, onHover, tooltip },
	ref,
) => {
	const isButtonDisabled = isLoading || isDisabled;
	const isTooltipDisabled = isButtonDisabled || isPopoverOpen;

	return (
		<DownloadCSVButtonTooltip content={tooltip} isDisabled={isTooltipDisabled}>
			<div className={!className ? styles.container : className}>
				<Button
					ref={ref}
					aria-haspopup
					data-thc-button
					reverse
					aria-label={downloadButtonLabel || String(T.translate('button.ariaLabel'))}
					data-testid="download-button"
					disabled={isButtonDisabled}
					icon={DownloadIcon}
					label={downloadButtonLabel || String(T.translate('button.label'))}
					loading={isLoading}
					showLabel={!!downloadButtonLabel}
					size="medium"
					type="button"
					variant="secondary"
					{...applyCypressData(cypressId)}
					onClick={onClick}
					onMouseEnter={onHover}
				/>
			</div>
		</DownloadCSVButtonTooltip>
	);
};

export default forwardRef(DownloadCSVButton);
